import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReportFooterTimestamp, tableCellStyle } from '../../../utils/reportUtils';
import { formatDate } from '../../../utils/dateUtils';

interface DrugListComponentProps {
  // eslint-disable-next-line
  DrugListData?: any[];
}

const DrugListReport: React.FC<DrugListComponentProps> = ({ DrugListData }) => {
  const { t: tGeneral } = useTranslation('general');
  const { t: tTP } = useTranslation('treatmentPlan_config');


  return (
    <Box sx={{ p: '0px 35px 35px 35px', backgroundColor: '#fff', color: '#333', fontFamily: 'Arial, sans-serif' }}>
      <Box component="hr" sx={{ my: 2, borderColor: '#ccc' }} />
      <Typography variant="h6" sx={{ mb: 1, color: '#444' }}>{tTP('DrugList_Report')}</Typography>
      <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2, mb: 4 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {[
                tGeneral('drugName'),
                tGeneral('genericName'),
                `${tGeneral('strength')}/${tGeneral('strengthType')}`,
                tGeneral('frequency'),
                tGeneral('instructions'),
                tGeneral('days'),
                tGeneral('qty'),
                tGeneral('UOM'),
                tGeneral('route'),
                tGeneral('notes'),
                tGeneral('doctor'),
                tGeneral('date'),
              ].map((heading, i) => (
                <TableCell
                  key={i}
                  sx={{
                    ...tableCellStyle,
                    fontWeight: 'bold',
                    backgroundColor: '#f5f5f5',
                    ...(heading === tGeneral('genericName') ? { maxWidth: 110, width: 110, minWidth: 110, whiteSpace: 'normal' } : {})
                  }}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {/* eslint-disable-next-line */}
            {DrugListData?.map((drugItem: any, i: number) => (
              <TableRow key={drugItem.id || i}>
                <TableCell sx={tableCellStyle}>{drugItem?.drug?.name_label ?? '-'}</TableCell>
                <TableCell sx={{ ...tableCellStyle, maxWidth: 110, width: 110, minWidth: 110, whiteSpace: 'normal', wordBreak: 'break-word' }}>{drugItem?.drug?.molecule_label ?? drugItem?.drug?.molecule ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.drug?.strength ?? '-'} / {drugItem?.drug?.strength_type ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.frequency ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.instructions_label ?? drugItem?.instructions ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.no_of_days ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.quantity ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.drug?.stock_uom_code ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.drug_route_code_label ?? drugItem?.drug?.route_code ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.notes ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.user_full_name ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>
                  {formatDate(drugItem?.created_on) || '-'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ReportFooterTimestamp />

    </Box>
  );
};

export default DrugListReport;